import type { Client } from "@opensea/graphql"
import type { Address } from "@opensea/utils"
import { prefetchProfileCurrencyStatsTable } from "@/components/stats/ProfileCurrencyStatsTable/ProfileCurrencyStatsTable"
import { prefetchProfilePageLayout } from "../../layout-query"

export function prefetchProfileTokensPage(address: Address, client: Client) {
  prefetchProfileCurrencyStatsTable(address, client)
  prefetchProfilePageLayout(address, client)
}
